<mat-form-field class="full-width reset-margin--bottom">
    <mat-label i18n="@@input-label-sortby">Sort by</mat-label>
    <mat-select (selectionChange)="sortBy($event.value)" [(value)]="selectedOption">
        @for (option of options; track option) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
        }
    </mat-select>
</mat-form-field>
